import { Column, Row, Tag } from 'components/Blocks';
import { loaders } from 'entities';
import {
  ConfirmRepriceButton,
  ConfirmRepriceButtonProps,
} from 'pages/PendingActions/RepriceRequest/ConfirmButton';
import { useProjectProfile } from 'pages/Projects/ProjectProfile/context';
import { Trans } from 'react-i18next';

interface ConfirmPricesButtonProps extends ConfirmRepriceButtonProps {
  children?: never;
}

export function ConfirmPricesButton(props: ConfirmPricesButtonProps) {
  const { id } = useProjectProfile();

  const [sampleProjects] = loaders.projects.projectSampleIds.useV2({
    params: { projectId: id },
    defaultValue: [],
  });

  return (
    <ConfirmRepriceButton
      {...props}
      footer={
        sampleProjects.length ? (
          <Column gap="2">
            <p>
              <Trans
                i18nKey="cpi-projects-affected"
                components={{
                  CPI: <span className="font-semibold text-primary" />,
                }}
              />
            </p>

            <Row flexWrap="wrap" gap="2">
              {sampleProjects.map((sampleId) => (
                <Tag name={sampleId} color="primary" key={sampleId} />
              ))}
            </Row>
          </Column>
        ) : null
      }
    />
  );
}
